import { render, staticRenderFns } from "./VulnSourceNvd.vue?vue&type=template&id=4014e320&"
import script from "./VulnSourceNvd.vue?vue&type=script&lang=js&"
export * from "./VulnSourceNvd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports